// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.7893 2.00053L22 8.21116V22.0001H2V2.00049L15.7893 2.00053ZM7 4.00027V9H11V4L7 4.00027ZM7 13V15H17V13H7ZM7 16V18H13V16H7Z"}}]};

const SystemStorageFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-storage-filled',
    ref,
    icon: element,
  },
));

SystemStorageFilledIcon.displayName = 'SystemStorageFilledIcon';

export default SystemStorageFilledIcon;
